/* eslint-disable default-case,@typescript-eslint/no-unused-vars */

import { COMPONENT_TYPE } from '../../../../../app/constants/component_type';

xplenty.directive('databaseDestination', [
  function () {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./database-destination.html'),

      replace: true,

      scope: false,

      controller: [
        '$scope',
        '$translate',
        function ($scope, $translate) {
          $scope.operationTypes = [];
          $scope.tableNameHintText = null;
          $scope.onOperationTypeChange = (operationType) => {
            $scope.component.operation_type = operationType;
          };

          $scope.bodyDataOptionsPre = {
            lineWrapping: true,
            lineNumbers: true,
            mode: 'text/x-sql',
            placeholder: 'CREATE TABLE <target_table> (...)',
          };

          $scope.bodyDataOptionsPost = {
            lineWrapping: true,
            lineNumbers: true,
            mode: 'text/x-sql',
            placeholder: 'CREATE INDEX ix ON <target_table> (...)',
          };

          $scope.hasWarehouse = false;
          $scope.hasDatabase = false;
          $scope.hasSchema = false;
          $scope.hasTable = false;
          $scope.hasCreateTable = false;
          $scope.hasCreateColumns = false;
          $scope.hasOperationType = false;
          $scope.hasPreSQL = false;
          $scope.hasPostSQL = false;

          const OPERATION_TYPE_INSERT = {
            value: 'append',
            text: `database-destination.selects.operation_type.options.${$scope.component.componentType}.insert`,
            translate: true,
          };
          const OPERATION_TYPE_APPEND = {
            value: 'append',
            text: `database-destination.selects.operation_type.options.${$scope.component.componentType}.append`,
            translate: true,
          };
          const OPERATION_TYPE_TRUNCATE_AND_INSERT = {
            value: 'truncate_and_insert',
            text: `database-destination.selects.operation_type.options.${$scope.component.componentType}.truncate_and_insert`,
            translate: true,
          };
          const OPERATION_TYPE_DELETE_AND_INSERT = {
            value: 'delete_and_insert',
            text: `database-destination.selects.operation_type.options.${$scope.component.componentType}.delete_and_insert`,
            translate: true,
          };
          const OPERATION_TYPE_MERGE = {
            value: 'merge',
            text: `database-destination.selects.operation_type.options.${$scope.component.componentType}.merge`,
            translate: true,
          };
          const OPERATION_TYPE_INSERT_OR_UPDATE = {
            value: 'insert_or_update',
            text: `database-destination.selects.operation_type.options.${$scope.component.componentType}.insert_or_update`,
            translate: true,
          };
          const OPERATION_TYPE_MERGE_UPDATE_AND_INSERT = {
            value: 'merge_update_and_insert',
            text: `database-destination.selects.operation_type.options.${$scope.component.componentType}.merge_update_and_insert`,
            translate: true,
          };

          switch ($scope.component.componentType) {
            case COMPONENT_TYPE.SNOWFLAKE_DESTINATION_COMPONENT:
              $scope.hasWarehouse = false;
              $scope.hasDatabase = false;
              $scope.hasSchema = true;
              $scope.hasTable = true;
              $scope.hasCreateTable = true;
              $scope.hasCreateColumns = true;
              $scope.hasOperationType = true;
              $scope.hasPreSQL = true;
              $scope.hasPostSQL = true;
              $scope.operationTypes = [
                OPERATION_TYPE_APPEND,
                OPERATION_TYPE_TRUNCATE_AND_INSERT,
                OPERATION_TYPE_DELETE_AND_INSERT,
                OPERATION_TYPE_MERGE,
                OPERATION_TYPE_MERGE_UPDATE_AND_INSERT,
              ];
              break;

            case COMPONENT_TYPE.DATABASE_DESTINATION_COMPONENT:
            case COMPONENT_TYPE.AMAZON_REDSHIFT_DESTINATION_COMPONENT:
              $scope.hasSchema = true;
              $scope.hasTable = true;
              $scope.hasCreateTable = true;
              $scope.hasCreateColumns = true;
              $scope.hasOperationType = true;
              $scope.hasPreSQL = true;
              $scope.hasPostSQL = true;
              $scope.operationTypes = [
                OPERATION_TYPE_APPEND,
                OPERATION_TYPE_TRUNCATE_AND_INSERT,
                OPERATION_TYPE_DELETE_AND_INSERT,
                OPERATION_TYPE_MERGE,
                OPERATION_TYPE_MERGE_UPDATE_AND_INSERT,
              ];
              break;

            case COMPONENT_TYPE.SPANNER_DESTINATION_COMPONENT:
              $scope.hasTable = true;
              $scope.hasCreateTable = true;
              $scope.hasCreateColumns = true;
              $scope.hasOperationType = true;
              $scope.hasPreSQL = true;
              $scope.hasPostSQL = true;
              $scope.operationTypes = [OPERATION_TYPE_APPEND, OPERATION_TYPE_INSERT_OR_UPDATE, OPERATION_TYPE_MERGE];
              break;

            case COMPONENT_TYPE.BIG_QUERY_DESTINATION_COMPONENT:
              $scope.hasTable = true;
              $scope.hasCreateTable = true;
              $scope.hasCreateColumns = true;
              $scope.hasOperationType = true;
              $scope.operationTypes = [OPERATION_TYPE_APPEND, OPERATION_TYPE_TRUNCATE_AND_INSERT, OPERATION_TYPE_MERGE];
              break;

            case COMPONENT_TYPE.MONGO_DESTINATION_COMPONENT:
              $scope.hasTable = true;
              $scope.hasOperationType = true;
              $scope.operationTypes = [OPERATION_TYPE_INSERT, OPERATION_TYPE_MERGE_UPDATE_AND_INSERT];
              $scope.tableNameHintText = $translate.instant(
                'database-destination.labels.mongo_destination_component.table_name_hint',
              );
              break;
          }
        },
      ],
    };
  },
]);
